"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaysOfWeek = exports.DaysOfWeekShort = void 0;
exports.DaysOfWeekShort = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
exports.DaysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//# sourceMappingURL=DayOfWeek.js.map